export { default, type LiveGradientSectionProps } from './LiveGradientSection';
